<template>
  <div>
    <TextField
      v-if="textField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :value="value"
      :prefix="prefix"
      :suffix="suffix"
      :toAssign="toAssign()"
      :rules="rules"
      :foreignKey="foreignKey"
      :browseHelp="browseHelp"
      :inputFields="inputFields"
      :mask="mask"
      :queryFlag="queryFlag"
      :length="length"
      :secLength="secLength"
      :upperLower="upperLower"
      :coordinates="coordinates"
      :hint="hint"
      :index="index"
      :fillTo="fillTo"
      :filler="filler"
      @field-change="handleChange"
      @handle-key-down="handleKeyDown"
      @handle-browse-help="handleBrowseHelp"
      @handle-foreign-key="handleForeignKey"
      ref="fieldRef"
    />
    <NumberField
      v-if="numberField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :value="value"
      :prefix="prefix"
      :suffix="suffix"
      :toAssign="toAssign()"
      :rules="rules"
      :foreignKey="foreignKey"
      :browseHelp="browseHelp"
      :inputFields="inputFields"
      :mask="mask"
      :queryFlag="queryFlag"
      :length="length"
      :secLength="secLength"
      :upperLower="upperLower"
      :coordinates="coordinates"
      :hint="hint"
      @field-change="handleChange"
      @handle-key-down="handleKeyDown"
      @handle-browse-help="handleBrowseHelp"
      @handle-foreign-key="handleForeignKey"
      ref="fieldRef"
    />
    <DateField
      v-if="dateField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :value="value"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :rules="rules"
      :queryFlag="queryFlag"
      :customLanguage="customLanguage"
      :coordinates="coordinates"
      @field-change="handleChange"
      @handle-key-down="handleKeyDown"
      ref="fieldRef"
    />
    <TimeField
      v-if="timeField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :value="value"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :rules="rules"
      :queryFlag="queryFlag"
      :customLanguage="customLanguage"
      :coordinates="coordinates"
      @field-change="handleChange"
      @handle-key-down="handleKeyDown"
      ref="fieldRef"
    />
    <ComboField
      v-if="comboSimpleField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :items="items"
      :value="value"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :rules="rules"
      :inputFields="inputFields"
      :queryFlag="queryFlag"
      :loading="loading"
      :coordinates="coordinates"
      :generalExApplicationEx="generalExApplicationEx"
      :customLanguage="customLanguage"
      @field-change="handleChange"
      @handle-key-down="handleKeyDown"
      ref="fieldRef"
    />
    <TagsField
      v-if="comboTagField(dictionary) || comboTagListField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :items="items"
      :value="value"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :rules="rules"
      :tags="dictionary.tags"
      :list="dictionary.list"
      :inputFields="inputFields"
      :queryFlag="queryFlag"
      :loading="loading"
      :coordinates="coordinates"
      :generalExApplicationEx="generalExApplicationEx"
      :customLanguage="customLanguage"
      :dictionary="dictionary"
      @field-change="handleChange"
      @handle-key-down="handleKeyDown"
      ref="fieldRef"
    />
    <CheckField
      v-if="checkField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :value="value"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :queryFlag="queryFlag"
      :rules="rules"
      :coordinates="coordinates"
      :hint="hint"
      :link="link"
      @field-change="handleChange"
      ref="fieldRef"
    />
    <PasswordField
      v-if="passwordField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :value="value"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :rules="rules"
      :queryFlag="queryFlag"
      :coordinates="coordinates"
      :hint="hint"
      @field-change="handleChange"
      @handle-key-down="handleKeyDown"
      ref="fieldRef"
    />
    <FileField
      v-if="fileInputField(dictionary) && !signatureField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :value="value"
      :rules="rules"
      :queryFlag="queryFlag"
      :generalExApplicationEx="generalExApplicationEx"
      :dictionary="dictionary"
      :uploaded="uploaded"
      :selected="selected"
      :progress="progress"
      :loading="loading"
      :coordinates="coordinates"
      :url="url"
      @field-change="handleChange"
      @set-loading="setLoading"
      ref="fieldRef"
    />
    <MemoField
      v-if="memoField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :value="value"
      :prefix="prefix"
      :suffix="suffix"
      :rules="rules"
      :queryFlag="queryFlag"
      :coordinates="coordinates"
      :length="length"
      :secLength="secLength"
      @field-change="handleChange"
      ref="fieldRef"
    />
    <SnippetField
      v-if="snippetField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :value="value"
      :prefix="prefix"
      :suffix="suffix"
      :rules="rules"
      :queryFlag="queryFlag"
      :coordinates="coordinates"
      @field-change="handleChange"
      ref="fieldRef"
    />
    
    <EmbedField
      v-if="embedField(dictionary) && fieldAccess() != 'hidden'"
      :id="id"
      :coordinates="coordinates"
      :environment="environment"
      :inputFields="inputFields"
      :session="session"
      :generalExApplicationEx="generalExApplicationEx"
      :customLanguage="customLanguage"
      :permission="permission"
      :dictionary="dictionary"
      :screen="screen"
      :formData="formData"
      :access="fieldAccess()"
      :value="value"
      @update-notification="updateNotification"
      @field-change="handleChange"
      ref="fieldRef"
    />

    <SignatureField  
      v-if="signatureField(dictionary)"
      :id="id"
      :name="name"
      :access="fieldAccess()"
      :customStyle="customStyle"
      :label="label"
      :dataType="dictionary.dataType"
      :pattern="pattern"
      :value="value"
      :prefix="prefix"
      :suffix="suffix"
      :rules="rules"
      :queryFlag="queryFlag"
      :coordinates="coordinates"
      :url="url"
      @field-change="handleChange"
      ref="fieldRef"
    />    
  </div>
</template>

<script>
import TextField from "./TextField";
import DateField from "./DateField";
import TimeField from "./TimeField";
import ComboField from "./ComboField";
import CheckField from "./CheckField";
import PasswordField from "./PasswordField";
import FileField from "./FileField";
import MemoField from "./MemoField";
import SnippetField from "./SnippetField";
import NumberField from "./NumberField";
import TagsField from "./TagsField";
import EmbedField from "./EmbedField";
import SignatureField from './SignatureField';

export default {
  name: "FormField",
  props: [
    "id",
    "name",
    "access",
    "customStyle",
    "label",
    "items",
    "value",
    "prefix",
    "suffix",
    "dictionary",
    "align",
    "rules",
    "pattern",
    "general",
    "uploaded",
    "selected",
    "progress",
    "loading",
    "permission",
    "method",
    "keyPos",
    "foreignKey",
    "browseHelp",
    "inputFields",
    "generalExApplicationEx",
    "mask",
    "queryFlag",
    "length",
    "secLength",
    "customLanguage",
    "upperLower",
    "coordinates",
    "hint",
    "link",
    "object",
    "index",
    // For Embed
    "environment",
    "screen",
    "formData",
    "session",
    "url",
    "fillTo",
    "filler"
  ],
  data() {
    return {};
  },
  components: {
    TextField,
    DateField,
    TimeField,
    ComboField,
    CheckField,
    PasswordField,
    FileField,
    MemoField,
    SnippetField,
    NumberField,
    TagsField,
    EmbedField,
    SignatureField
  },
  methods: {
    handleChange(data) {
      this.$emit("handle-change", data);
    },

    handleKeyDown(key, id) {
      this.$emit("handle-key-down", key, id);
    },

    handleBrowseHelp(data) {
      this.$emit("handle-browse-help", data);
    },

    handleForeignKey(data) {
      this.$emit("handle-foreign-key", data);
    },

    fieldAccess() {
      return this.getFieldAccess(this.access, this.permission, this.method);
    },

    toAssign() {
      return this.method == "post" && this.keyPos >= 1;
    },

    setValue(value, autoSource) {
      this.$refs.fieldRef.setValue(value, autoSource);
    },

    setLoading(status) {
      this.$emit("set-loading", status);
    },

    /*
    embedInputData() {
      return this.buildInputData(this.inputFields);
    },

    callEmbedField() {
      if (this.embedField(this.dictionary)) {
        if (
          this.$refs.embedFieldRef &&
          this.value &&
          this.embedMounted != this.value
        ) {
          this.embedMounted = this.value;
          this.$refs.embedFieldRef.callTransaction(
            {
              transactionName: this.value,
              selected: true,
              permission: this.permission,
            },
            null
          );
        }
      }
    },
    */

    updateNotification(data) {
      this.$emit("update-notification", data);
    },

  },
  updated() {},
  mounted() {
    //this.callEmbedField();
  },
};
</script>

<style>
</style>